(() => {
  const setup = (root) => {
    root.querySelectorAll('.featured-product media-gallery').forEach((gallery) => {
      if (gallery.dataset.finimadeGalleryReady) return;
      gallery.dataset.finimadeGalleryReady = 'true';
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      const list = viewer?.querySelector('[id^="Slider-Gallery"]');
      const controls = viewer?.querySelector('.slider-buttons');
      if (!list || !controls) return;
      const slides = () => Array.from(list.children).filter((el) => el.dataset.mediaId);
      const desktop = () => window.matchMedia('(min-width: 750px)').matches;
      const refresh = () => {
        const items = slides();
        let index = items.findIndex((el) => el.classList.contains('is-active'));
        if (!desktop()) {
          index = items.reduce((best, el, i) => Math.abs(el.getBoundingClientRect().left - list.getBoundingClientRect().left) < Math.abs(items[best].getBoundingClientRect().left - list.getBoundingClientRect().left) ? i : best, 0);
        }
        index = Math.max(0, index);
        controls.hidden = items.length < 2;
        controls.querySelector('.slider-counter--current').textContent = index + 1;
        controls.querySelector('.slider-counter--total').textContent = items.length;
        controls.querySelector('[name="previous"]').disabled = index === 0;
        controls.querySelector('[name="next"]').disabled = index === items.length - 1;
      };
      viewer.addEventListener('click', (event) => {
        const button = event.target.closest('.slider-buttons button');
        if (!button || !desktop() || gallery.dataset.desktopLayout !== 'thumbnail_slider') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const items = slides();
        const index = Math.max(0, items.findIndex((el) => el.classList.contains('is-active')));
        const next = items[index + (button.name === 'next' ? 1 : -1)];
        if (next && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(next.dataset.mediaId, false);
        refresh();
      }, true);
      new MutationObserver(refresh).observe(list, { subtree:true, attributes:true, attributeFilter:['class'], childList:true });
      list.addEventListener('scroll', refresh, { passive:true });
      window.addEventListener('resize', refresh, { passive:true });
      requestAnimationFrame(refresh);
    });
  };
  const run = () => customElements.whenDefined('media-gallery').then(() => setup(document));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once:true }); else run();
  document.addEventListener('shopify:section:load', run);
})();
